import * as THREE from "three";
import {sc} from "../LHQ/Scene.js";
import _ from "lodash";
import {computeBoundsTree, disposeBoundsTree, acceleratedRaycast} from "three-mesh-bvh";

// Add the extension functions
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;

export const PrepForFastRaycasting = (mesh: THREE.Mesh)=>{
	mesh.geometry.boundsTree = mesh.geometry.computeBoundsTree();
};

export const StandardMeshFix = (mesh: THREE.Mesh)=>{
	/*FlipNormals(mesh);
	ReverseWindingOrder(mesh);
	//mesh.material["side"] = THREE.DoubleSide;
	//ReverseGeometryYAxisValues(mesh);
	ReverseGeometryValues(mesh);
	/*const attr = mesh.geometry.attributes.position;
	for (let i = 2; i < attr.array.length; i += 3) {
		attr.array[i] = -attr.array[i];
	}
	for (let i = 0; i < attr.array.length; i += 3) {
		attr.array[i] = -attr.array[i];
	}*#/
	//FlipAroundXAxis(mesh);
	//FlipAroundYAxis(mesh);
	FlipAroundZAxis(mesh);

	//ReverseGeometryValuesOnAxis(mesh, "x");*/

	//mesh["invertNormalsForDirectLighting"] = true;
	//mesh["invertNormalsForDirectLighting_shaderOnly"] = true;
	//mesh["invertNormalsForLightmap"] = true;
	//mesh["invertNormalsForLightmap_shaderOnly"] = true;




	//ReverseWindingOrder(mesh);
	//mesh.material["side"] = THREE.BackSide;



	mesh.geometry.computeBoundingBox();
	mesh.geometry.computeBoundingSphere();
	//mesh.geometry.computeBoundsTree();
	//mesh.geometry.computeVertexNormals();
	mesh.geometry.computeTangents();

	//mesh["excludeFromLightMap"] = true;
	//mesh["excludeFromDirectLight"] = true;

	mesh.castShadow = true;
	mesh.receiveShadow = true;
};

export const FloorMeshFix = (mesh: THREE.Mesh)=>{
	if (1) return;

	/*FlipNormals(mesh);
	ReverseWindingOrder(mesh);
	//mesh.material["side"] = THREE.DoubleSide;
	//ReverseGeometryYAxisValues(mesh);
	ReverseGeometryValues(mesh);
	//FlipAroundXAxis(mesh);
	//FlipAroundYAxis(mesh);
	FlipAroundAxis(mesh, "z");
	//ReverseGeometryValuesOnAxis(mesh, "x");*/

	//mesh["invertNormalsForDirectLighting"] = true;
	//mesh["invertNormalsForDirectLighting_shaderOnly"] = true;
	//mesh["invertNormalsForLightmap"] = true;
	//mesh["invertNormalsForLightmap_shaderOnly"] = true;

	ReverseWindingOrder(mesh);
	mesh.material["side"] = THREE.BackSide;

	/*mesh.geometry.computeBoundingBox();
	mesh.geometry.computeBoundingSphere();
	//mesh.geometry.computeBoundsTree();
	//mesh.geometry.computeVertexNormals();
	mesh.geometry.computeTangents();*/
};

export const StandardMat_FallbackColor = ()=>new THREE.Color("rgb(100,100,100)");
export function IfMaterialIsEmptyThenChangeColorToX(mat: THREE.Material | THREE.Material[], color: THREE.Color) {
	const mats = Array.isArray(mat) ? mat : [mat];
	for (const mat of mats) {
		if (mat instanceof THREE.MeshStandardMaterial || mat instanceof THREE.MeshPhongMaterial || mat instanceof THREE.MeshBasicMaterial || mat instanceof THREE.MeshLambertMaterial || mat instanceof THREE.MeshPhysicalMaterial) {
			if (mat.map == null && mat.color.r == 1 && mat.color.g == 1 && mat.color.b == 1) {
				mat.color = color;
			}
		}
	}
}
export function CreateBasicMatFromStandardMat(sourceMat: THREE.MeshStandardMaterial): THREE.MeshBasicMaterial {
	return new THREE.MeshBasicMaterial({
		color: sourceMat.color,
		opacity: sourceMat.opacity,
		transparent: sourceMat.transparent,
		depthWrite: sourceMat.depthWrite,
		depthTest: sourceMat.depthTest,
		side: sourceMat.side,
		// maps/textures
		map: sourceMat.map,
		alphaMap: sourceMat.alphaMap,
		envMap: sourceMat.envMap,
		fog: sourceMat.fog,
	});
}
export function CreateLambertMatFromStandardMat(sourceMat: THREE.MeshStandardMaterial): THREE.MeshLambertMaterial {
	return new THREE.MeshLambertMaterial({
		color: sourceMat.color,
		opacity: sourceMat.opacity,
		transparent: sourceMat.transparent,
		depthWrite: sourceMat.depthWrite,
		depthTest: sourceMat.depthTest,
		side: sourceMat.side,
		normalScale: sourceMat.normalScale,
		// maps/textures
		map: sourceMat.map,
		alphaMap: sourceMat.alphaMap,
		envMap: sourceMat.envMap,
		fog: sourceMat.fog,
		normalMap: sourceMat.normalMap ?? undefined,
	});
}

export const MeshMatch = (node: THREE.Object3D<THREE.Object3DEventMap>, baseName: string)=>{
	return node.name == baseName || node.name.startsWith(`${baseName}_`); // exporter or threejs sometimes splits large meshes, apparently
};
export const MeshMatchIn = (node: THREE.Object3D<THREE.Object3DEventMap>, baseNames: string[])=>{
	return baseNames.some(baseName=>MeshMatch(node, baseName));
};

export function ProcessModel(opt: {
	scene: THREE.Group<THREE.Object3DEventMap>,
	lightmapObjects: THREE.Object3D[],

	nodesThatDoNotCast: string[],
	nodesForLightmap: string[],
	extraNodesForLightmap?: (node: THREE.Object3D<THREE.Object3DEventMap>)=>boolean,
	nodesToHide: string[],
	applyFixes?: "standard" | false,
	addDirectlyToScene_scene?: THREE.Scene|n,
}) {
	const queuedRemovalOps = [] as (()=>any)[];
	const queuedAddOps = [] as (()=>any)[];

	opt.scene.traverse(node=>{
		if (node["ignore"]) return;
		console.log("NodeName:", node.name); //, node); // commented "node" inclusion when not needed, since has lots of data and can cause OOM crash

		if (node["isMesh"]) {
			const mesh = node as THREE.Mesh;

			if (opt.applyFixes == "standard") {
				StandardMeshFix(mesh);
			}

			//console.log("NodeName:", node.name, node.position);

			node.castShadow = !MeshMatchIn(node, opt.nodesThatDoNotCast);
			//if (!node.castShadow) console.log("Found!:", node);
			node.receiveShadow = true;

			node["material"] = new THREE.MeshPhongMaterial(); //{color: 0xffffff, depthWrite: true});

			// create a uv1 for mesh, if one doesn't exist yet (just clone uv0)
			/*const geometry = node["geometry"] as THREE.BufferGeometry;
			if (geometry && geometry.attributes.uv1 == null) {
				geometry.setAttribute("uv1", geometry.attributes.uv.clone());

				// temp; use attributes["uv"] (importer appears to not have its code updated to r151+ pattern of uv0, uv1, etc.)
				/*geometry.setAttribute("uv", geometry.attributes.uv);
				geometry.setAttribute("uv1", geometry.attributes.uv.clone());
				geometry.setAttribute("uv2", geometry.attributes.uv.clone());*#/
			}*/

			//lhq.lightmapObjects.push( node );

			// if in hide list, hide completely (check this first; if node is in hide list, that has highest priority)
			if (MeshMatchIn(node, opt.nodesToHide)) {
				node.layers.disableAll(); // disable rendering
				node.traverse(desc=>desc.layers.disableAll()); // disable rendering for all descendants
			}
			// if in lightmap list, add to lightmap
			else if (MeshMatchIn(node, opt.nodesForLightmap) || opt.extraNodesForLightmap?.(node)) {
				if (!opt.lightmapObjects.includes(node)) opt.lightmapObjects.push(node);
				node.traverse(desc=>{
					if (desc["isMesh"]) {
						if (!opt.lightmapObjects.includes(desc)) opt.lightmapObjects.push(desc);
					}
				});
			}
			// else, still render, but don't include in lightmap
			else {
			}
		} /*else {
			node.layers.disableAll(); // Disable Rendering for this // todo: is this needed?
		}*/

		if (opt.addDirectlyToScene_scene) {
			console.log("Adding:", node, "To:", opt.addDirectlyToScene_scene);
			queuedRemovalOps.push(()=>opt.addDirectlyToScene_scene!.add(node));
		}
	});

	queuedRemovalOps.forEach(op=>op());
	queuedAddOps.forEach(op=>op());
}

export function FlipNormals(mesh: THREE.Mesh) {
	for (let i = 0; i < mesh.geometry.attributes.normal.array.length; i++) {
		mesh.geometry.attributes.normal.array[i] = -mesh.geometry.attributes.normal.array[i];
	}
}

export function FlipUVs(mesh: THREE.Mesh) {
	const attr = mesh.geometry.attributes.uv;
	for (let i = 0; i < attr.array.length; i += 2) {
		attr.array[i] = 1 - attr.array[i];
	}
}

export function ReverseWindingOrder(mesh: THREE.Mesh) {
	const indices = mesh.geometry.index!.array;
	const newIndices = [] as number[];
	for (let i = 0; i < indices.length; i++) {
		newIndices[i] = indices[indices.length - 1 - i];
	}
	/*const newIndices = [] as number[];
	for (let i = 0; i < indices.length; i += 3) {
		let triangle_reversed = [indices[i + 2], indices[i + 1], indices[i]];
		newIndices[i] = triangle_reversed[0];
		newIndices[i + 1] = triangle_reversed[1];
		newIndices[i + 2] = triangle_reversed[2];
	}*/
	mesh.geometry.setIndex(newIndices);
}
export function ReverseGeometryValuesOnAxis(mesh: THREE.Mesh, axis: "x" | "y" | "z") {
	const attr = mesh.geometry.attributes.position;
	for (let i = axis == "x" ? 0 : axis == "y" ? 1 : 2; i < attr.array.length; i += 3) {
		attr.array[i] = -attr.array[i];
	}
}
export function ReverseGeometryValues(mesh: THREE.Mesh) {
	const attr = mesh.geometry.attributes.position;
	for (let i = 0; i < attr.array.length; i++) {
		attr.array[i] = -attr.array[i];
	}
}

export function FlipAroundAxis(mesh: THREE.Mesh, axis: "x" | "y" | "z") {
	mesh.rotation[axis] += Math.PI;
}